import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

interface NavCategory {
  id: string;
  name: string;
  slug: string;
  icon: string;
}

interface NavbarProps {
  categories: NavCategory[];
}

export default function Navbar({ categories }: NavbarProps) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="mx-auto px-4 md:px-6 max-w-[1400px]">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 flex-shrink-0">
            <span className="text-xl md:text-2xl font-heading font-bold text-foreground-950 tracking-tight">
              今日看料
            </span>
            <span className="hidden md:inline text-xs text-foreground-500 font-light tracking-wider mt-1">
              全网吃瓜入口
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="px-4 py-2 text-sm text-foreground-700 hover:text-primary-500 transition-colors duration-200 font-medium whitespace-nowrap"
              >
                <i className={`${cat.icon} mr-1.5 text-xs`}></i>
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="flex items-center gap-3">
            <Link
              to="/category/heiliao-jinri"
              className="hidden md:flex items-center gap-1.5 bg-primary-500 text-background-50 px-5 py-2 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-2-line"></i>
              APP 下载
            </Link>
            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-full hover:bg-background-200 transition-colors cursor-pointer"
              aria-label="菜单"
            >
              <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl text-foreground-800`}></i>
            </button>
          </div>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-1">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="flex items-center gap-2 px-3 py-3 text-sm text-foreground-700 hover:bg-background-100 rounded-lg transition-colors"
                onClick={() => setMobileOpen(false)}
              >
                <i className={`${cat.icon} text-base`}></i>
                {cat.name}
              </Link>
            ))}
            <Link
              to="/category/heiliao-jinri"
              className="flex items-center justify-center gap-2 mt-2 bg-primary-500 text-background-50 px-4 py-3 rounded-full text-sm font-medium cursor-pointer"
              onClick={() => setMobileOpen(false)}
            >
              <i className="ri-download-2-line"></i>
              APP 下载
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}